import { React, useEffect, useState, useMemo, useCallback } from 'react';
import { Tooltip, Button, IconButton } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { projectInuseDetailAtom, projectListInCorporationByUserIdAtom } from '@/state/atom/projectAtom';
import LoadingPanel from '../common/LoadingPanel';
import { 
    setPanelSelector,
    triggerReloadTicketListByPanelType, 
    triggerReloadTab,
    closePanelTabSelector, 
    updatePanelAfterCreateTicketSelector
} from '@/state/selector/panelSelector';
import {
    triggerReLoadKnowledgeTicketDetailAtom
} from '@/state/atom/ticketKnowledgeAtom';
import { updateUserWorkspacePanel } from '@/common/utils/ServiceFactoryUtil';
import { cloneDeep } from 'lodash';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import {
    acceptBackToDraftButton,
    acceptDeleteKnowledgeButton,
    acceptRestoreKnowledgeTicket,
    acceptHardDeleteKnowledgeTicket,
    closeCallbackBackToDraftButton,
    closeCallbackDeleteKnowledgeButton,
    closeCallbackRestoreKnowledgeTicketButton,
    getTicketDetailHandler,
    isSettingPermissionChanged,
    onClickDeleteKnowledge,
    handleConfirmAccessDenied,
} from './handler/DetailTicketHandler';
import RenderFieldUI from '../formManagement/RenderFieldUI';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import CustomSchema from '@/schema/CustomSchema';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { multiPanelAtom, closeTabId, panelInitDataAtom, lastActivePanelIdAtom} from '@/state/atom/panelAtom';
import { DialogConfirmCancelEditTicket } from '../chatThread/editTicketDialog/DialogConfirmCancelEditTicket';
//Edit Ticket
import { API, I18n } from 'aws-amplify';
import { bulkCreateTagItem } from '@/service/formManagementService';
import { useSnackbar } from 'notistack';
import {
    updateTabNameAfterEditTicket,
    submitUpdateTicketKnowledge,
} from './handler/DetailTicketHandler';

import { handlerShowButtonEditTicket, isShowFieldEventTypeChatThread } from '../ticketList/handler/KnowledgeTicketHandler';
import SettingPermissionKnowledgeTicket from '../ticketList/knowledge/SettingPermissionKnowledgeTicket';
import AiAutoLog from '../ticketList/knowledge/AiAutoLog';
import { getListActiveB2BCustomerSelector, getListActiveB2BHelpdeskSelector } from '@/state/selector/ticketSelector';
import { getTicketById } from '@/service/ticketService';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import DuplicateATicket from './elements/DuplicateATicket';
import './DetailTicketKnowledge.css'

import moment from 'moment';
import {showLoadingMouse, hideLoadingMouse} from '@/common/utils/CustomCursor';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { getPanelInitData, updatePanelInitData, removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import crypto from 'crypto-js';
import { isDisplayExtractText, isDisplayVectorUrlAndTotalToken } from '@/component/ticketKnowledge/handler/DetailTicketHandler';
import { validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';
import { openShareLinkTicket } from '../chatThread/handler/MessageHandler';
import { viewTicketKnowledgeDetailDuplicate, closePanelTabDetailTicket } from '../ticketList/handler/TicketHandler';
import { activeFormForDuplicate } from '../formManagement/handler/FormListHandler';
import { formListOfProjectSelector } from '@/state/selector/formSelector';
import { isInputAllFieldRequiredWhenEditTicket } from '../chatThread/handler/DetailTicketHandler';
import Bookmark from './elements/Bookmark/Bookmark';
import TagDefaultBookmark from './elements/Bookmark/TagDefaultBookmark';
import { signOut } from '@/service/authenService';
import UserTagPrivateBookmarkCount from './elements/Bookmark/UserTagPrivateBookmarkCount';
import TaggedBookmarkListName from './elements/Bookmark/TaggedBookmarkListName';
import AssigneeUI from '../formManagement/fieldUI/AssigneeFieldUI';

import { getCorporationById } from '@/service/organizationService';
import { getProjectById } from '@/service/projectService';
import { getProjectMemberList } from '@/component/ticketList/handler/HelpDeskTicketListHandler';
import { getAssignList } from '@/component/ticketList/handler/TicketListHandler';
import { Storage } from 'aws-amplify';
import CopyShortLink  from '@/component/ticketKnowledge/elements/CopyShortLink';
import { PropTypes } from 'prop-types';

DetailTicketKnowledge.propTypes = {
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    ticketId: PropTypes.any
};

export default function DetailTicketKnowledge(props) {
    const [currentUserDetail, setCurrentUserDetail] = useRecoilState(userAtom);
    const isGeneralUser = Utils.isGeneralUser(currentUserDetail);
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    const [selectedProject, setSelectedProject] = useRecoilState(projectInuseDetailAtom);
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const listB2BCustomer = useRecoilValue(getListActiveB2BCustomerSelector);
    const listB2BHelpdesk = useRecoilValue(getListActiveB2BHelpdeskSelector);

    const [triggerReLoadKnowledgeTicketDetail, setTriggerReLoadKnowledgeTicketDetail] = useRecoilState(
        triggerReLoadKnowledgeTicketDetailAtom
    );

    const [detailTicket, setDetailTicket] = useState({});
    const [fieldListDefaultData, setFieldListDefaultData] = useState([]);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);

    const [listFieldData, setListFieldData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [listFieldEdited, setListFieldEdited] = useState([]);
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUpdatedList, setFileUpdatedList] = useState([]);
    const [fileUploading, setFileUploading] = useState({});
    const [mapDataIdToId, setMapDataIdToId] = useState({});
    const [isDisplayEditTicket, setIsDisplayEditTicket] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [formDetail, setFormDetail] = useState({});
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);

    const [ticketOutline, setTicketOutline] = useState('');
    const [settingTitle, setSettingTitle] = useState([]);

    const [dataSettingDefaults, setDataSettingDefaults] = useState({});
    const [viewPermissions, setViewPermissions] = useState([]);
    const [editPermissions, setEditPermissions] = useState([]);
    const [additionalViewPermissions, setAdditionalViewPermissions] = useState([]);
    const [additionalEditPermissions, setAdditionalEditPermissions] = useState([]);
    const [chatPermission, setChatPermission] = useState('');

    const [hasEditSettingPermissions, setHasEditSettingPermissions] = useState(false);
    const [hasEditFieldPermissions, setHasEditFieldPermissions] = useState(false);
    const [hasChatPermission, setHasChatPermission] = useState(false);
    const [hasViewPermission, setHasViewPermission] = useState(false);
    const [isConfirmCancelEditTicket, setIsConfirmCancelEditTicket] = useState(false);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [isOpenModalReloadPageMain, setIsOpenModalReloadPageMain] = useState(false);
    const [isOpenModalTicketDeleted, setIsOpenModalTicketDeleted] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    
    const [disableButtonCallBack, setDisableButtonCallBack] = useState(false);

    const [isShowAiAutoLog, setIsShowAiAutoLog] = useState(false);
    
    // Delete button
    const [isOpenDialogConfirmDeleteKnowledge, setIsOpenDialogConfirmDeleteKnowledge] = useState(false);
    const reloadPanelAfterSoftDeleteTicketByPanelType = useSetRecoilState(triggerReloadTab);
    
    // Back to draft
    const [isOpenDialogConfirmBackToDraft, setIsOpenDialogConfirmBackToDraft] = useState(false);
    const updatePanelAfterBackToDraft = useSetRecoilState(updatePanelAfterCreateTicketSelector);
    
    // Restore button
    const [isShowDialogRestoreTicket, setIsShowDialogRestoreTicket] = useState(false);

    // Delete button
    const [isShowDialogDeleteTicket, setIsShowDialogDeleteTicket] = useState(false);

    useEffect(() => {
        registerEditTicket('fileUploadList');
    }, [])

    const validateEditTicket = useForm({
        mode: 'all',
        resolver: yupResolver(CustomSchema(fieldListDefaultData))
    });
    const handleSubmitEditTicket = validateEditTicket.handleSubmit;
    const errorEditTicket = validateEditTicket.errors;
    const clearErrors = validateEditTicket.clearErrors;
    const setValueEditTicket = validateEditTicket.setValue;
    const registerEditTicket = validateEditTicket.register;
    const getValuesEditTicket = validateEditTicket.getValues;
    const setErrorEditTicket = validateEditTicket.setError;
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [isTagList, setIsTagList] = useState(false);
    const [tagListValue, setTagListValue] = useState([]);
    const [isEditTicket, setIsEditTicket ] = useState(false);
    const [corporationAffiliationTicket, setCorporationAffiliationTicket] = useState({});
    const [titleLineNumber, setSettingTitleLineNumber] = useState(0);

    // Switch tab state
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [currentPanelInitData, setCurrentPanelInitData] = useState({});
    const lastActivePanelId = useRecoilValue(lastActivePanelIdAtom);
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);

    const [isShowExtractedText, setIsShowExtractedText] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenNotFoundTicketPopup,setIsOpenNotFoundTicketPopup] = useState(false)
    const [isOpenRestoreTicketErrorPopup, setIsRestoreTicketErrorPopup] = useState(false);
    const [isOpenModalActiveForm, setIsOpenModalActiveForm] = useState(false);
    const [formList, setFormList] = useRecoilState(formListOfProjectSelector);
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);
    // const [isLoadingNotRefreshData, setIsLoadingNotRefreshData] = useState(false)
    /**
     * created for ai auto. this state will be set options by dependent field. ex: ai auto. selected ticket type field , will be query form list by ticket type.
     * this state value is format array object with key which is any. !) with ai auto: key is sysField of dependent field.
     */
    const [optionsOfTagField, setOptionsOfTagField] = useState({})
    const [aiAutoSelectedData, setAIAutoSelectedData] = useState({});

    const userOfProjectList = useRecoilValue(projectListInCorporationByUserIdAtom);
    const [ticketAffiliationProject, setTicketAffiliationProject] = useState({})
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: I18n.get('MSG-CM-DELETED-CONTENT'),
        confirmTxt: I18n.get('CM-BUTTON-OK')
    });

    // Assignee
    const [currentAssigneeUserData, setCurrentAssigneeUserData] = useState({});
    const [newAssigneeData, setNewAssigneeData] = useState({});
    const [newAssignee, setNewAssignee] = useState('');
    const [assignList, setAssignList] = useState([]);
    const [flagReset, setFlagReset] = useState(false);
    const [isMe, setIsMe] = useState(false);

    const argsAll = {
        ...props,
        API: props?.API,
        currentUserDetail,
        corporationDetail,
        selectedProject,
        isProjectManager,
        listB2BCustomer,
        listB2BHelpdesk,
        detailTicket,
        setDetailTicket,
        fieldListDefaultData,
        setFieldListDefaultData,
        listFieldData,
        setListFieldData,
        isLoading,
        setIsLoading,
        isEdited,
        setIsEdited,
        ticketOutline,
        setTicketOutline,
        settingTitle, 
        setSettingTitle,
        formDetail,
        setFormDetail,
        listFieldEdited,
        setListFieldEdited,
        setMapDataIdToId,
        
        dataSettingDefaults, 
        setDataSettingDefaults,
        viewPermissions, 
        setViewPermissions,
        editPermissions, 
        setEditPermissions,
        additionalViewPermissions, 
        setAdditionalViewPermissions,
        additionalEditPermissions, 
        setAdditionalEditPermissions,
        chatPermission, 
        setChatPermission,

        hasViewPermission,
        setHasViewPermission,
        hasEditSettingPermissions,
        setHasEditSettingPermissions,
        hasEditFieldPermissions,
        setHasEditFieldPermissions,
        hasChatPermission,
        setHasChatPermission,
        reloadTicketListByPanelType,
        
        panelList,
        setPanelList,
        closePanelTab,

        isOpenDialogConfirmDeleteKnowledge, 
        setIsOpenDialogConfirmDeleteKnowledge,
        isOpenDialogConfirmBackToDraft, 
        setIsOpenDialogConfirmBackToDraft,
        isShowDialogRestoreTicket,
        setIsShowDialogRestoreTicket,
        isShowDialogDeleteTicket,
        setIsShowDialogDeleteTicket,
        reloadPanelAfterSoftDeleteTicketByPanelType,
        enqueueSnackbar,
        updatePanelAfterBackToDraft,

        isOpenModalReloadPageMain, 
        setIsOpenModalReloadPageMain,
        isTagList,
        setIsTagList,
        tagListValue,
        setTagListValue,
        isEditTicket,
        setIsEditTicket,
        fileUploadList,
        setFileUploadList,
        fileUpdatedList,
        setFileUploading,
        setCorporationAffiliationTicket,
        currentPanelInitData,
        setCurrentPanelInitData,
        lastUserAction,
        setLastUserAction,
        titleLineNumber,
        setSettingTitleLineNumber,
        setIsOpenModalTicketDeleted,
        setIsOpenAccessDeniedPopup,
        isOpenModalReloadPage,
        setIsOpenModalReloadPage,
        addNewPanel,
        setIsShowPopupLogout,
        ticketAffiliationProject,
        corporationAffiliationTicket,
        setTicketAffiliationProject,

        newAssigneeData,
        setNewAssigneeData,
        newAssignee,
        setNewAssignee,
        flagReset,
        setFlagReset,
        setAssignList,
        setCurrentAssigneeUserData,
        aiAutoSelectedData,
        setErrorEditTicket,
        setIsRestoreTicketErrorPopup,
        panelInitData
    };

    const currentTabData = useMemo(() => {
        const panel = panelInitData.find(p => p.id === props.panelId);
        if (!panel) return;
        const tab = (panel?.tabList || []).find(t => t.id === props.tabId)?.data;
        return tab
    }, [panelInitData, props.tabId, props.panelId]);

    const filterDefaultValue = (value) => {
        if(Utils.isEmptyArray(value)) {
            return [];
        }

        let newValue = []
        let newFileUploadedList = value.filter(item => !Utils.isImageFile(item.fileName));
        // get list image
        let fileImageList = value.filter(item => Utils.isImageFile(item.fileName));
        newValue = [...newFileUploadedList, ...fileImageList]
        return newValue
    }

    const handleGetTicketDetail = async () => {
        setIsLoading(true);

        const ticketDetail = await getTicketDetailHandler(
            argsAll,
            props.ticketId,
            props.panelId,
            props.tabId,
            props.triggerReload ? {} : panelInitData,
            panelList
        );

        // validate display AI Auto Log
        const isAIAutoForm = Utils.isSystemAIAutoForm(ticketDetail.formDetail);
        const isUsingAIAuto = Utils.isCorporationOnAIAuto(corporationDetail);
        
        setIsShowAiAutoLog(isAIAutoForm && isUsingAIAuto)

        let currentPanelInitDataRes = getPanelInitData(props.panelId, props.tabId, panelInitData);
        if (currentPanelInitDataRes && !Utils.isEmptyObject(currentPanelInitDataRes)) {
            setCurrentPanelInitData(currentPanelInitDataRes);
            if (currentPanelInitDataRes.isEditedData) {
                setIsEdited(true);
            }
            if (currentPanelInitDataRes.fileUploadList) {
                setFileUploadList(currentPanelInitDataRes.fileUploadList);
            }
            if (currentPanelInitDataRes.fileUpdatedList) {
                setFileUpdatedList(filterDefaultValue(currentPanelInitDataRes.fileUpdatedList));
            }
            if (currentPanelInitDataRes.aiAutoSelectedData) {
                setAIAutoSelectedData(currentPanelInitDataRes.aiAutoSelectedData);
            }
        }
        setIsLoading(false);

        await handleAfterGetTicketDetail(ticketDetail)

        // fake
        return ticketDetail
    }

    const handleAfterGetTicketDetail = async (ticketDetail) => {
        let ticketCorpData = corporationDetail;
        if (ticketDetail.affiliationOrganization !== corporationDetail?.id) {
            ticketCorpData = await getCorporationById(props.API, ticketDetail.affiliationOrganization);
        }
        setCorporationAffiliationTicket(ticketCorpData);

        let ticketProjectData = selectedProject;
        if (ticketDetail.affiliationProject !== selectedProject?.id) {
            ticketProjectData = await getProjectById(props.API, ticketDetail?.affiliationProject)
        }
        setTicketAffiliationProject(ticketProjectData);

        let prjMemberList = await getProjectMemberList([], null, ticketDetail?.affiliationProject)

        let assigneeList = getAssignList(prjMemberList, currentUserDetail);
        setAssignList(assigneeList);

        if (!Utils.isEmptyObject(ticketDetail?.personInChargeInfo)) {
            if (ticketDetail?.personInChargeInfo?.avatar) {
                let avatarData = await Storage.get(ticketDetail?.personInChargeInfo?.avatar);
                ticketDetail.personInChargeInfo = {
                    ...ticketDetail.personInChargeInfo,
                    avatar: avatarData
                }
            }
    
            setCurrentAssigneeUserData({
                ...ticketDetail?.personInChargeInfo,
                assigneeIcon: ticketDetail?.personInChargeInfo?.shortName,
                assigneeFullName: ticketDetail?.personInChargeInfo?.fullName
            });
        } else {
            setCurrentAssigneeUserData({});
        }
    }


    // handle get init ticketDetail
    useEffect(() => {

        handleGetTicketDetail()
    }, []);

    // handle get init ticketDetail when have trigger reload
    useEffect(() => {
        // console.log('useEffect 1')
        if (
            props.triggerReload ||
            triggerReLoadKnowledgeTicketDetail === props.ticketId
        ) {

            console.log('---- 1', props.triggerReload)
            console.log('---- 11', triggerReLoadKnowledgeTicketDetail)
            handleGetTicketDetail()

            setTriggerReLoadKnowledgeTicketDetail('');
        }
    }, [props.triggerReload, triggerReLoadKnowledgeTicketDetail])

    useEffect(() => {
        // console.log('useEffect 2')
        // save listFieldEdited to panel
        if (listFieldEdited.length) {
            const newlistFieldEdited = [...new Set([ ...(currentTabData?.listFieldEdited || []), ...listFieldEdited])];
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'listFieldEdited', newlistFieldEdited);
        }
    }, [listFieldEdited]);

    useEffect(() => {
        // console.log('useEffect 3')
        if (
            props.tabId === closeTabIdState ||
            (props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE &&
                closeTabIdState === detailTicket.id
            )
        ) { 
            if (isEdited) {
                setIsConfirmCancelEditTicket(true);
            } else {
                closePanelTabDetailTicket(
                    isEdited,
                    setIsConfirmCancelEditTicket,
                    Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                    props.panelId,
                    detailTicket,
                    panelList,
                    closePanelTab,
                    setCloseTabIdState
                )
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        // console.log('useEffect 4')
        if (isLoading) {
            return showLoadingMouse();
        } 
        return hideLoadingMouse();
    
     }, [isLoading]);

     


    //  Switch tab
    useEffect(() => {
        // console.log('useEffect 5')
        if (lastActivePanelId && lastActivePanelId.panelId === props.panelId && isEdited) {
            let formData = getValuesEditTicket();
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'formData', formData);
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isEdited);
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'fileUploadList', fileUploadList);
        }
    }, [lastActivePanelId, isEdited]);

    useEffect(() => {
        // console.log('useEffect 6')
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isEdited);
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'corporationSelectedId', props?.corporationSelectedId);
    }, [isEdited])

    useEffect(() => {
        // console.log('useEffect 7')
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'fileUploadList', fileUploadList);
    }, [fileUploadList])
    

    useEffect(() => {
        // console.log('useEffect 8')
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'fileUpdatedList', fileUpdatedList);
        if(!Utils.isEmptyObject(currentPanelInitData) && currentPanelInitData?.hasOwnProperty('fileUpdatedList')){
            let currentPanelInitDataClone = cloneDeep(currentPanelInitData)
            currentPanelInitDataClone.fileUpdatedList = [...fileUpdatedList]
            setCurrentPanelInitData({...currentPanelInitDataClone})
        }
    }, [fileUpdatedList])

    useEffect(() => {
        // console.log('useEffect 9')
        let settingPermission = {
            viewPermission: viewPermissions,
            editPermission: editPermissions,
            additionalViewPermission: additionalViewPermissions,
            additionalEditPermission: additionalEditPermissions,
            chatPermission: chatPermission
        };
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'settingPermission', settingPermission);
    }, [viewPermissions, editPermissions, additionalViewPermissions, additionalEditPermissions, chatPermission]);

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'aiAutoSelectedData', aiAutoSelectedData);
    }, [aiAutoSelectedData])

    const bookmarkTargetType = useMemo(() => {
        return Utils.getBookmarkTargetTypeByTicketType(detailTicket?.ticketType);
    }, [detailTicket]);

    const getHyperLink = useCallback(() => {
        // console.log('useEffect 10', detailTicket)
        if (props.tabId.includes(Constant.TAB_PANEL_TYPE.KNOWLEDGE_CREATE_TICKET)) return;
        if (!detailTicket.id) return '';
        let uriObj = {};
        let projectList = [];
        let orgHasReadPermission = [];
        let userHasReadPermission = [];
    
        uriObj = {
            projectList,
            orgHasReadPermission,
            userHasReadPermission,
            keyFile: `/knowledge/${detailTicket.id}-vectordata.json`,
            publicAll: true
        };
    
        const enCodeUriObj = encodeURIComponent(
            crypto.AES.encrypt(JSON.stringify(uriObj), Constant.S3_URL_AES_ENCODE_KEY).toString()
        );
        const newUri = `/${enCodeUriObj}`;
        return `${process.env.REACT_APP_CLOUD_FRONT_URL}${newUri}`;
    }, [detailTicket]);
    
    const openChatThreadPanel = ticketDetail => {
        console.log('openChatThreadPanel props', props)
        addNewPanel({
            //update
            type: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
            tabId: ticketDetail.id,
            props,
            ticketId: ticketDetail.id,
            ticketOutline: ticketDetail.outline,
            isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false
        });
    };

    const getPanelType = () => {
        let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, panelList);
        if (currentPanelIndex === -1) return '';
        let currentPanel = panelList[currentPanelIndex];
        return currentPanel.type;
    };
    
    const getTicketListType = () => {
        return getPanelType() === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL
            ? Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            : Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST;
    };

    const handleEditTicketSubmit = async (formData, closeTab) => {
        if (isDisableBtnSaveTicket()) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);

        const detailTicketLatest = await getTicketById(props?.API, props.ticketId);
        let isDataChanged = isSettingPermissionChanged(detailTicket, detailTicketLatest);
        if (isDataChanged) {
            setIsLoading(false);
            setIsOpenModalReloadPageMain(true);
            return;
        }

        let fields = Utils.getEditTicketData(formData, fieldListDefaultData, aiAutoSelectedData);
        if (validateExceedSizeOfFieldTicket(argsAll.fieldListDefaultData, argsAll.setFieldListDefaultData, fields)) {
            argsAll.setIsLoading(false);
            return;
        }
        let tagField = fields.tagField;
        if (!Utils.isEmptyObject(tagField)) {
            for (const fieldId in tagField) {
                let listNewItem = [];
                for (const item of tagField[fieldId]) {
                    if (item?.isNewItem) {
                        const parentField = fieldListDefaultData.find(
                            field => field.fieldId === fieldId
                        );
                        const itemData = {
                            usage: Constant.FORM_USAGE.TAG,
                            name: JSON.stringify({
                                jp: {
                                    A: 'F',
                                    text: item.title
                                }
                            }),
                            affiliationOrganization: parentField.affiliationOrganization,
                            affiliationProject: parentField.affiliationProject,
                            affiliationField: parentField.id,
                            creator: currentUserDetail.id,
                            updator: currentUserDetail.id,
                            type: '',
                            structure: JSON.stringify({
                                isShowItemInTicket: true,
                                no: item.no
                            }),
                            viewForCustomer: JSON.stringify({}),
                            definition: Constant.FORM_DEFINITION.USER,
                            explanation: JSON.stringify({}),
                            usingProjects: parentField.usingProjects,
                            hitNumber: 0,
                            hasValue: true
                        };
                        listNewItem.push(itemData);
                    }
                }
                const listNewId = await bulkCreateTagItem(props?.API, listNewItem);
                fields[fieldId].push(...listNewId);
            }
        }
        delete fields.tagField;
        let updateData = {
            id: detailTicket.id,
            affiliationOrganization: detailTicket.affiliationOrganization
        };

        let fieldEdited = currentTabData?.listFieldEdited || [] || listFieldEdited;
        let newFieldEditedList = [...fieldEdited];
        // Add hidden field in form
        if (formDetail?.definition === Constant.FORM_DEFINITION.SYSTEM && formDetail?.definitionVariant === Constant.FORM_VARIANT.AI_AUTO.EVENT) {
            let fieldEventTypeChatThread = fieldListDefaultData.find(field => field.sysField === Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER);
            if (fieldEventTypeChatThread) {
                newFieldEditedList.push(fieldEventTypeChatThread?.id);
                newFieldEditedList = [...new Set(newFieldEditedList)];
                if (!isShowFieldEventTypeChatThread(aiAutoSelectedData)) {
                    formData[fieldEventTypeChatThread?.id] = [];
                    fields[fieldEventTypeChatThread?.id] = [];
                }
            }
        }

        let editedFieldValue = Utils.getFieldsValueEdited(formData, fields, mapDataIdToId);
        editedFieldValue = await Utils.putFieldDataToS3BeforeEditTicket(editedFieldValue, mapDataIdToId, fieldListDefaultData, detailTicket);
        
        const args = { ...argsAll, listFieldEdited: newFieldEditedList };
        const updateResult = await submitUpdateTicketKnowledge(
            props?.API,
            updateData,
            setIsLoading,
            setIsDisplayEditTicket,
            fileUploadList,
            fileUpdatedList,
            setFileUploading,
            setFileUploadList,
            detailTicket,
            fieldListDefaultData,
            formData,
            currentUserDetail,
            editedFieldValue,
            mapDataIdToId,
            false,
            args
        );
       
        
        if(!Utils.isEmptyObject(updateResult) && updateResult.errorCode == Constant.MSG_CM_DELETED_TICKET){
            setIsLoading(false);
            setIsOpenModalTicketDeleted(true)
            return
        }

        if (updateResult?.isConfirm) {
            setIsLoading(false);
            return;
        }

        if(!Utils.isEmptyObject(updateResult) && updateResult.errorCode === Constant.MSG_SD_DUPLICATED_SCRIPT_TITLE) {
            let currentPanelInitDataClone = cloneDeep(currentPanelInitData)
            currentPanelInitDataClone.formData = {...formData}
            setCurrentPanelInitData({...currentPanelInitDataClone})          
            return setIsLoading(false);
        }

        const newArgsAll = {...argsAll, getValuesEditTicket, setCurrentPanelInitData, isFromEditTicket: true}
        let newTicketDetail = await getTicketDetailHandler(newArgsAll, detailTicket.id, props.panelId, props.tabId, panelInitData, []);
        
        setCurrentPanelInitData({});
        removePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData);
        updateTabNameAfterEditTicket(argsAll, newTicketDetail.outline, props.panelId, detailTicket.id);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST
        });
        setIsEdited(false);
        setListFieldEdited([])
        setIsLoading(false);

        setIsOpenModalTicketDeleted(false)
        if (typeof closeTab === 'function') {
            closeTab({
                event: null,
                panelType: getPanelType(),
                panelId: props.panelId,
                tabId: detailTicket.id
            });
        }
        
        setCloseTabIdState(0);
        enqueueSnackbar(I18n.get('MSG-CM-SAVE-CONTENT-SUCCESSFULLY'), {
            variant: 'success',
            autoHideDuration: 3000
        });
        
        await handleAfterGetTicketDetail(newTicketDetail)
    };

    const handleReRestoreSubmit = () => {
        const outlineField = fieldListDefaultData?.find(
            field => field?.sysField?.toLowerCase() === Constant.SYS_FIELD.OUTLINE
        );
        let fieldOutlineIdUpdate = [outlineField.id];
        acceptRestoreKnowledgeTicket(
            API,
            detailTicket,
            currentUserDetail,
            argsAll,
            fieldOutlineIdUpdate
        )

        setIsRestoreTicketErrorPopup(false);
    }

    const cancelEditTicket = async e => {
        handleResetFormData();
    };

    
    const handleResetFormData = () => {
        let newFieldListDefaultData = cloneDeep(fieldListDefaultData);
        setFieldListDefaultData(newFieldListDefaultData);

        if (!Utils.isEmptyArray(fieldListDefaultData)) {
            fieldListDefaultData.forEach(field => {
                if (!Utils.isEmptyObject(field)) {
                    setValueEditTicket(field.id, field.defaultValue);
                }
            });
        }

        // reset setting permission
        let dataSettingDefault = {
            viewPermission: detailTicket.viewPermission,
            editPermission: detailTicket.editPermission,
            additionalViewPermission: detailTicket.additionalViewPermission,
            additionalEditPermission: detailTicket.additionalEditPermission,
            chatPermission: detailTicket.chatPermission
        };
        setDataSettingDefaults(dataSettingDefault);

        // Clear all err
        clearErrors();
        setIsEdited(false);
        setFileUploadList([]);
        setListFieldEdited([])
    };

    const setShowButtonEditTicket = (value) => {
        let formData = getValuesEditTicket()
        handlerShowButtonEditTicket(value, argsAll, formData)
    }

    const getDefaultValueOfField = fieldData => {
        if (fieldData.structure.UI === Constant.FIELD_UI.DROP_FILE) {
            return fieldData.defaultValue;
        }

        let defaultValue =
            currentPanelInitData.formData && currentPanelInitData.formData[fieldData.fieldId]
                ? currentPanelInitData.formData[fieldData.fieldId]
                : fieldData.defaultValue;

        return defaultValue;
    };

    const handleReloadTicketDeleted = async () => {
        setDisableButtonCallBack(true);
        await updateUserWorkspacePanel(detailTicket.id, false);

        window.location.reload();
    };

    const onClickUrlViewTicket = async (url) => {
        setIsLoading(true)
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            currentUserDetail.id,
            selectedProject.id,
            {
                ...props,
                setIsLoading,
                API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setSelectedProject,
                userDetail: currentUserDetail,
                setUserDetail: setCurrentUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    }

    const isActiveFormInProject = () => {
        return formDetail.usingProjects.includes(selectedProject.id);
    }

    const onClickDuplicate = async () => {
        if (!isActiveFormInProject()) {
            setIsOpenModalActiveForm(true);
        } else {
            setIsOpenModalActiveForm(false);
            await viewTicketKnowledgeDetailDuplicate(props, 'ticketId', addNewPanel, setLastUserAction, false, detailTicket);
        }
    }

    const handlerActiveForm = async () => {
        setIsOpenModalActiveForm(false);
        setIsLoading(true);
        // handler data active form
        await activeFormForDuplicate(props?.API, formList, selectedProject.id, formDetail, setFormList);
        // open tab duplicate
        await viewTicketKnowledgeDetailDuplicate(props, 'ticketId', addNewPanel, setLastUserAction, false, detailTicket);
        setIsLoading(false);
        return hideLoadingMouse();
    }

    const isDisableBtnSaveTicket = () => {
        if (!isInputAllFieldRequiredWhenEditTicket(fieldListDefaultData, [...fileUploadList, ...fileUpdatedList], getValuesEditTicket, aiAutoSelectedData) || !Utils.isEmptyObject(errorEditTicket)) {
            return true;
        }

        return !(isEdited && isEditTicket);
    }

    return (
        <div style={{ height: '100%' }}>
            {isLoading ? (
                <LoadingPanel isLoading={isLoading} />
            ) : (
                <div className="mainWrap detail-ticket-knowledge-body">
                    {(hasEditFieldPermissions || hasEditSettingPermissions) && (
                        <div className="btnHead">
                            {Utils.isEmptyString(detailTicket?.deletedAt) && (
                                <div className="btnHead-btn">
                                    {hasEditFieldPermissions === true && (
                                        <Button
                                            className="btn-send btn-hg32 btn-handle-delete-user-agree btn-delete"
                                            variant="contained"
                                            // disabled={isShowButtonDelete}
                                            onClick={() => onClickDeleteKnowledge(argsAll)}
                                        >
                                            {I18n.get('COMBTN013')}
                                        </Button>
                                    )}
                                    {argsAll.currentUserDetail.id === detailTicket.creator && (
                                        <Button
                                            className="btn-send btn-outline-primary btn-hg32 back-to-draft"
                                            variant="contained"
                                            color="primary"
                                            onClick={() => setIsOpenDialogConfirmBackToDraft(true)}
                                        >
                                            下書きに戻す
                                        </Button>
                                    )}
                                    <Button
                                        className="btn-send  btn-primary btn-hg32"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmitEditTicket(handleEditTicketSubmit)}
                                        disabled={isDisableBtnSaveTicket()}
                                    >
                                        保存
                                    </Button>
                                </div>
                            )}
                            {!Utils.isEmptyString(detailTicket?.deletedAt) && (
                                <div className="btnHead-btn">
                                    <>
                                        <Button
                                            className="btn-send btn-delete btn-hg32"
                                            variant="contained"
                                            color="primary"
                                            onClick={() => setIsShowDialogDeleteTicket(true)}
                                        >
                                            完全削除
                                        </Button>
                                        <Button
                                            className="btn-send btn-outline-primary btn-hg32"
                                            variant="contained"
                                            color="primary"
                                            onClick={() => setIsShowDialogRestoreTicket(true)}
                                        >
                                            復元
                                        </Button>
                                    </>
                                </div>
                            )}
                        </div>
                    )}

                    <div className="scrollBar-main detailTicketKnowledge flex-column">
                        {!Utils.isEmptyString(detailTicket.deletedAt) && (
                            <div className="form-addTicket">
                                <div className="alert-complete-delete-ticket">
                                    <p>
                                        本チケットは削除した日付から30日以内で復元可能です。
                                        <br />
                                        {moment(detailTicket.deletedAt)
                                            .add(30, 'days')
                                            .format('YYYY/MM/DD')}
                                        に自動的に完全削除されます。
                                    </p>
                                </div>
                            </div>
                        )}
                        <div className="titleTicket title-ticket-knowledge">
                            {/* Bookmark */}
                            <TagDefaultBookmark
                                className={'ticket-knowledge-detail-tag-default'}
                                isViewDelete={!Utils.isEmptyString(detailTicket.deletedAt)}
                                ticketKnowledge={detailTicket}
                                corporationDetail={corporationDetail}
                                projectInuseDetail={selectedProject}
                                userDetail={currentUserDetail}
                                setTriggerReloadKnowledgeListPanel={reloadTicketListByPanelType}
                                bookmarkTargetType={bookmarkTargetType}
                            />

                            {/* Ticket Title */}
                            {titleLineNumber === 2 ? (
                                <label className="titleDisplay titleTicket-titlev2 title-knowledge-display">
                                    {ticketOutline ? ticketOutline : '[概要 (現在未記入)]'}
                                </label>
                            ) : (
                                <Tooltip
                                    title={ticketOutline ? ticketOutline : '[概要 (現在未記入)]'}
                                >
                                    <label className="titleDisplay titleTicket-titlev2 title-clamp title-knowledge-display">
                                        {ticketOutline ? ticketOutline : '[概要 (現在未記入)]'}
                                    </label>
                                </Tooltip>
                            )}

                            {/* Ticket Options */}
                            <div className="titleTicket-btn btn-copy-link">
                                <DuplicateATicket 
                                    detailTicket={detailTicket}
                                    corporationDetail={corporationAffiliationTicket}
                                    onClickDuplicate={onClickDuplicate}
                                    formDetail={formDetail}
                                    selectedProject={selectedProject}
                                />
                                {!Utils.isEmptyObject(detailTicket?.dataShareLink) && (
                                    <CopyShortLink
                                        detailTicket={detailTicket}
                                        isGeneralUser={isGeneralUser}
                                        corporationDetail={corporationAffiliationTicket}
                                    />
                                )}
                                {hasChatPermission && detailTicket?.public === Constant.TICKET_PUBLIC.PUBLIC && (
                                    <div className="titleTicket-btn">
                                        <IconButton
                                            className="itemNav"
                                            onClick={() => openChatThreadPanel(detailTicket)}
                                            data-cy="detail-ticket-icon-chat"
                                            disabled={!hasViewPermission}
                                        >
                                            <img src="/assets/image/icon-chat.svg" alt="" />
                                        </IconButton>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Bookmark */}
                        <div className='ticket-bookmark-info'>
                            <Bookmark
                                isTicketBookmark={true}
                                isViewDelete={!Utils.isEmptyString(detailTicket.deletedAt)}
                                ticketKnowledge={detailTicket}
                                panelType={Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL}
                                isShowEdit={true}
                                bookmarkPopupContainerClassName={'reset-position-bookmark-popup-container'}
                            />
                            <div className="ticket-bookmark-info-wrap">
                                <div className='ticket-bookmark-info-text-wrap'>
                                    <TaggedBookmarkListName bookmarkListText={detailTicket?.bookmarkListText} className="ticket-bookmark-info-text" />
                                </div>

                                <UserTagPrivateBookmarkCount ticketKnowledge={detailTicket}/>
                            </div>
                        </div>
                        
                        {/* Ticket Form */}
                        <div className="addTicket addTicket-detail">
                            <FormProvider {...validateEditTicket}>
                                {!Utils.isEmptyArray(fieldListDefaultData) &&
                                    fieldListDefaultData
                                        ?.filter(
                                            field =>
                                                field.sysField !==
                                                    Constant.TICKET_DATA_ID.TICKET_ID &&
                                                (detailTicket.affiliationProject ===
                                                    selectedProject.id ||
                                                    field.publicForCustomer !==
                                                        Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW)
                                        )
                                        ?.map((fieldData, i) => {
                                            if (fieldData.sysField === Constant.SYS_FIELD.PERSON_IN_CHARGE) {
                                                return (
                                                    <AssigneeUI
                                                        setNewAssignee={setNewAssignee}
                                                        setIsEdited={setIsEdited}
                                                        assigneeUserData={currentAssigneeUserData}
                                                        setCurrentAssigneeUserData={
                                                            setCurrentAssigneeUserData
                                                        }
                                                        ticketDetail={detailTicket}
                                                        setNewAssigneeData={setNewAssigneeData}
                                                        isGeneralUser={isGeneralUser}
                                                        isManager={isProjectManager}
                                                        isDisplayButtonEditTicket={hasEditFieldPermissions}
                                                        assignList={assignList}
                                                        isHelpDesk={true}
                                                        setListFieldEdited={setListFieldEdited}
                                                        listFieldEdited={listFieldEdited}
                                                        setIsEditTicket={setIsEditTicket}
                                                        data={fieldData}
                                                        isShowIconCopyFieldId={false}
                                                        {...argsAll}
                                                        setFlagReset={setFlagReset}
                                                        isMe={isMe}
                                                        setIsMe={setIsMe}
                                                        isDisableAssign={!assignList.length}
                                                    />
                                                );
                                            }

                                            return (
                                                <RenderFieldUI
                                                    key={i}
                                                    {...argsAll}
                                                    API={props?.API}
                                                    UI={fieldData.structure.UI}
                                                    label={
                                                        fieldData.fieldLabel
                                                            ? Utils.getTextByLanguage(
                                                                  Constant.LANGUAGE_TYPE.JP,
                                                                  fieldData.fieldLabel
                                                              )
                                                            : ''
                                                    }
                                                    errorlist={errorEditTicket}
                                                    name={fieldData.fieldId}
                                                    data={fieldData}
                                                    defaultValue={getDefaultValueOfField(fieldData)}
                                                    // defaultValue={fieldData.defaultValue}
                                                    isEdited={isEdited}
                                                    setIsEdited={setIsEdited}
                                                    setListFieldEdited={setListFieldEdited}
                                                    listFieldEdited={listFieldEdited}
                                                    // Drop file props
                                                    fileUploadList={fileUploadList}
                                                    setFileUploadList={setFileUploadList}
                                                    register={registerEditTicket}
                                                    setValue={setValueEditTicket}
                                                    clearErrors={clearErrors}
                                                    setFileUpdatedList={setFileUpdatedList}
                                                    fileUpdatedList={fileUpdatedList}
                                                    getValues={getValuesEditTicket}
                                                    editTicket={true}
                                                    detailTicket={detailTicket}
                                                    viewFromProjectOfEscalateTicket={false}
                                                    setShowButtonEditTicket={
                                                        setShowButtonEditTicket
                                                    }
                                                    isLoading={isLoading}
                                                    setIsLoading={setIsLoading}
                                                    hasEditFieldPermissions={
                                                        hasEditFieldPermissions
                                                    }
                                                    parentForm={formDetail}
                                                    isDisplaySplitPdfSwitch={Utils.isDisplaySplitPdfSwitch(corporationDetail)}
                                                    projectInuseDetail={selectedProject}
                                                    currentUserDetail={currentUserDetail}
                                                    isShowIconCopyFieldId={false}
                                                    onClickUrlViewTicket={onClickUrlViewTicket}
                                                    optionsOfTagField={optionsOfTagField}
                                                    setOptionsOfTagField={setOptionsOfTagField}
                                                    aiAutoSelectedData = {aiAutoSelectedData}
                                                    setAIAutoSelectedData = {setAIAutoSelectedData}
                                                    isSystemSDAutoForm = {Utils.isSystemSDAutoForm(formDetail)}
                                                />
                                            );
                                        })}
                            </FormProvider>

                            <SettingPermissionKnowledgeTicket
                                {...argsAll}
                                parentScreen={'EditTicket'}
                                dataSettingDefaults={dataSettingDefaults}
                                hasEditSettingPermissions={hasEditSettingPermissions}
                                detailTicket={detailTicket}
                            />

                            {/* AI_AUTO_LOG */}
                            {isShowAiAutoLog && userOfProjectList.some(prj => prj.id === detailTicket.affiliationProject) && (
                                <AiAutoLog
                                    corporationDetail={corporationDetail}
                                    selectedProject={selectedProject}
                                    currentUserDetail={currentUserDetail}
                                    ticketDetail={detailTicket}
                                    panelId={props.panelId}
                                />
                            )}

                            {/* Extracted text area */}
                            {/* View 3 field: Extract/Vector/Token */}
                            {isShowExtractedText && (hasEditSettingPermissions || hasEditFieldPermissions) && (isDisplayExtractText(corporationAffiliationTicket, props.tabId) || isDisplayVectorUrlAndTotalToken(corporationAffiliationTicket, props.tabId)) && (
                                <div className='setting-permission-body'>
                                    <div className="setting-ticket-item">
                                        <span>{I18n.get('CM-LABEL-SYSTEM-ITEMS')}</span>
                                    </div>
                                    {isDisplayExtractText(corporationAffiliationTicket, props.tabId) && (
                                        <div className="setting-ticket-item">
                                            <span>{I18n.get('HYPERLINK-EXTRACT-TEXT')}</span>
                                            <span></span>
                                        </div>
                                    )}
                                    {isDisplayVectorUrlAndTotalToken(corporationAffiliationTicket, props.tabId) && (
                                        <>
                                            <div className="setting-ticket-item">
                                                <span>{I18n.get('HYPERLINK-VECTOR-DATA')}</span>
                                                <a
                                                    className="ticket-redirect"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={getHyperLink()}
                                                >
                                                    {getHyperLink() || ''}
                                                </a>
                                            </div>

                                            <div className="setting-ticket-item">
                                                <span>{I18n.get('CM-LABEL-TOKEN-NUMBER')}</span>
                                                <span>{detailTicket?.totalToken}</span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )} 

                        </div>

                        {/* Ticket Footer */}
                        <div className="detail-ticketKnowledge-info">
                            <div className="detailTicket-footer">
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-form">
                                        フォーマット：
                                        <span>{detailTicket?.usingFormName}</span>
                                    </div>
                                </div>
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-form">
                                        {I18n.get('CM-LABEL-FORMAT-ID')} :
                                        <span
                                            className="id-detail-ticket-copy"
                                            onClick={async () => {
                                                navigator.clipboard
                                                    .writeText(formDetail?.id)
                                                    .then(() => {})
                                                    .catch(err => {});
                                            }}
                                        >
                                            <img src="/assets/image/icon-copy.svg" alt="" />
                                        </span>
                                        <span className="field-form-id">{formDetail?.id}</span>
                                    </div>
                                </div>
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-info-time">
                                        投稿日時：<span>{detailTicket?.createTime}</span>
                                    </div>
                                    <div className="detail-ticketKnowledge-info-user">
                                        投稿ユーザー： 
                                        {/* <span>{detailTicket?.createrUserName}</span> */}
                                        <Tooltip title={detailTicket?.createrUserName}>
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    width: '55px'
                                                }}
                                            >
                                                {detailTicket?.createrUserName}
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>

                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-info-time">
                                        更新日時：<span>{detailTicket?.updatedTime}</span>
                                    </div>
                                    <div className="detail-ticketKnowledge-info-user">
                                        更新ユーザー：
                                        {/* <span>{detailTicket?.updatorUserName}</span> */}
                                        <Tooltip title={detailTicket?.updatorUserName}>
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    width: '55px'
                                                }}
                                            >
                                                {detailTicket?.updatorUserName}
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="id-detail-ticket-footer">
                                    {!isShowExtractedText && (hasEditSettingPermissions || hasEditFieldPermissions) && (isDisplayExtractText(corporationAffiliationTicket, props.tabId) || isDisplayVectorUrlAndTotalToken(corporationAffiliationTicket, props.tabId)) && (
                                        <div
                                            className={
                                                isShowExtractedText
                                                    ? 'show-extract-text-btn hidden'
                                                    : 'show-extract-text-btn'
                                            }
                                            onClick={e => setIsShowExtractedText(true)}
                                        >
                                            詳細
                                        </div>
                                    )}
                                    <div className="footer-ticket-id-data">
                                        <span className="id-detail-ticket-title">
                                            {I18n.get('USER04LB004')} :
                                        </span>
                                        <span
                                            className="id-detail-ticket-copy"
                                            onClick={async () => {
                                                navigator.clipboard
                                                    .writeText(detailTicket?.id)
                                                    .then(() => {})
                                                    .catch(e => console.log('copy ticketId e :>> ', e));
                                            }}
                                        >
                                            <img src="/assets/image/icon-copy.svg" alt="" />
                                        </span>
                                        <span id="ticketId">{detailTicket?.id}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Dialog group */}
            <DialogConfirmCancelEditTicket
                saveAndCancel={handleSubmitEditTicket(async(data) => {
                    await handleEditTicketSubmit(data);
                })}
                cancelEditTicket={cancelEditTicket}
                isConfirmCancelEditTicket={isConfirmCancelEditTicket}
                setIsConfirmCancelEditTicket={setIsConfirmCancelEditTicket}
                setCloseTabIdState={setCloseTabIdState}
                detailTicket={detailTicket}
                handleCancelTicket={() => {
                    setIsConfirmCancelEditTicket(false)
                    removePanelInitData(props?.panelId, props?.tabId, panelInitData, setPanelInitData);
                    closePanelTabDetailTicket(
                        false,
                        setIsConfirmCancelEditTicket,
                        Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                        props.panelId,
                        detailTicket,
                        panelList,
                        closePanelTab,
                        setCloseTabIdState
                    )
                }}
            />

            <DataChangePleaseReloadModal
                setCloseTabIdState={setCloseTabIdState}
                isOpen={isOpenModalReloadPageMain}
                setIsOpen={setIsOpenModalReloadPageMain}
            />

            {/* Dialog Soft Delete */}
            <ConfirmDialog
                isOpen={isOpenDialogConfirmDeleteKnowledge}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT')}
                closeCallBack={(e, reason) =>
                    closeCallbackDeleteKnowledgeButton(e, reason, argsAll)
                }
                okCallBack={() =>
                    acceptDeleteKnowledgeButton(
                        props?.API,
                        detailTicket,
                        currentUserDetail,
                        argsAll
                    )
                }
                textSubmit={I18n.get('CM-BUTTON-OK')}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
            />

            {/* Dialog Draft Ticket */}
            <ConfirmDialog
                isOpen={isOpenDialogConfirmBackToDraft}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-BACK-TO-DRAFT')}
                closeCallBack={(e, reason) =>
                    closeCallbackBackToDraftButton(e, reason, argsAll)
                }
                okCallBack={() =>
                    acceptBackToDraftButton(
                        props?.API,
                        detailTicket,
                        currentUserDetail,
                        argsAll
                    )
                }
                textSubmit={I18n.get('CM-BUTTON-OK')}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
            />

            <ConfirmDialog
                isOpen={isOpenModalTicketDeleted}
                msgConfirm={I18n.get('MSG-CM-DELETED-TICKET')}
                okCallBack={handleReloadTicketDeleted}
                disableButtonCallBack={disableButtonCallBack}
            />

            {/* Dialog Restore Ticket */}
            <ConfirmDialog
                isOpen={isShowDialogRestoreTicket}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-RESTORE-CONTENT')}
                closeCallBack={(e, reason) =>
                    closeCallbackRestoreKnowledgeTicketButton(e, reason, argsAll)
                }
                okCallBack={() => acceptRestoreKnowledgeTicket(
                    props?.API,
                    detailTicket,
                    currentUserDetail,
                    argsAll
                )}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />

            {/* Hard Delete ticket */}
            <ConfirmDialog
                isOpen={isShowDialogDeleteTicket}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-COMPLETELY')}
                closeCallBack={() => setIsShowDialogDeleteTicket(false)}
                okCallBack={() => acceptHardDeleteKnowledgeTicket(
                    props?.API,
                    detailTicket,
                    currentUserDetail,
                    argsAll,
                    setIsOpenModalReloadPageMain
                )}
                textSubmit={I18n.get('CM-BUTTON-OK')}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
            />
            
            {/* Dialog Access Denied*/}
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={() => handleConfirmAccessDenied(setIsOpenAccessDeniedPopup)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <DataChangePleaseReloadModal
                {...argsAll}
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={I18n.get('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={'はい'}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={I18n.get('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenModalActiveForm}
                msgConfirm={I18n.get('MSG-KNOW-CONFIRM-MOVE-FORM-DUPLICATE')
                    .replace('「Form_name」', formDetail?.name?.jp?.text)}
                okCallBack={() => handlerActiveForm()}
                closeCallBack={() => setIsOpenModalActiveForm(false)}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
            />
            <ConfirmDialog
                isOpen={isShowPopupLogout}
                msgConfirm={<div><span>{I18n.get('MSG-CM-EXPIRED-SESSION-1')}</span><br/><span>{I18n.get('MSG-CM-EXPIRED-SESSION-2')}</span></div>}
                textSubmit={I18n.get('CM-BUTTON-OK')}
                okCallBack={() => signOut()}
                cancelCallBack={() => setIsShowPopupLogout(false)}
                cancelClassName={'btn-confirm-cancel'}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />
            <ConfirmDialog
                isOpen={isOpenRestoreTicketErrorPopup}
                msgConfirm={I18n.get('MSG-SD-RESTORE-DUPLICATED-TITLE-SCRIPT')}
                okCallBack={e => handleReRestoreSubmit()}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
        </div>
    );
}
